import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Loader from '../../components/common/Loader';

const RedirectWorkOrderDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryId = queryParams.get('id');
    if (queryId) {
      navigate(`/work-orders/${queryId}`);
    } else {
      navigate('/');
    }
  }, [location]);

  return <Loader />;
};

export default RedirectWorkOrderDetails;
